import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalAlertService } from 'src/app/services/global-alert.service';
import { GlobalService } from 'src/app/services/global.service';
import { ApiProcesminetoArchivosService } from 'src/app/services/api-procesamiento-archivos.service';
import { ExcelService } from 'src/app/services/excel.service';
import { provisionData } from 'src/app/interfaces/provision';
import { facturacionData, informeFacturas } from 'src/app/interfaces/facturacion';


@Component({
  selector: 'app-facturacion',
  templateUrl: './facturacion.component.html',
})
export class FacturacionComponent implements OnInit {
  impr() {
    throw new Error('Method not implemented.');
  }
  medidores = [];
  memo;
  CentroCostos = new Array();
  Productos = new Array();
  MEDIDORESEXCEL;
  clientClass;
  seccionales = new Array();
  months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  Subir = false;
  Registrar = false;
  MesSel;
  AnoSel;
  IdSeccional;
  IdProducto;
  IdCentroCostos;
  VFacturar;
  VCU;
  VSubsidio;
  Cantidad;
  id_User;
  CodeProducto;
  VMCU;
  Oportuno;
  Suspende;
  Pe_inicio;
  Pe_final;
  newid;
  Cm;
  Dm;
  Gm;
  MesSelm;
  AnoSelm;
  IdSeccionalm;
  IdProductom;
  IdCentroCostosm;
  VFacturarm;
  VCUm;
  VSubsidiom;
  Cantidadm;
  id_Userm;
  CodeProductom;
  VMCUm;
  Oportunom;
  Suspendem;
  Pe_iniciom;
  Pe_finalm;
  Cmm;
  Dmm;
  Gmm;
  arrayBuffer: any;
  file: File;
  provisionState: boolean | undefined = undefined
  provisionData: provisionData
  facturacionData: informeFacturas[]
  reFacturacionData: informeFacturas[]
  @ViewChild('modalDuplicar') modalDuplicar: TemplateRef<any>;
  @ViewChild('modalConsolidado') modalConsolidado!: TemplateRef<any>;
  @ViewChild('content_modal_provision') content_modal_provision!: TemplateRef<any>;

  duplicaciones: number[] = [];
  idSolicitudOriginal: any;
  formConsolidado = {
    tipo: 'mensual',
    mes: null,
    anio: null,
    seccional: 'todas'
  };
  anios: number[] = [];
  mesSeleccionado: number = new Date().getMonth();
  anioSeleccionado: number = new Date().getFullYear();
  meses = [
    { num: 1, nombre: "Enero" },
    { num: 2, nombre: "Febrero" },
    { num: 3, nombre: "Marzo" },
    { num: 4, nombre: "Abril" },
    { num: 5, nombre: "Mayo" },
    { num: 6, nombre: "Junio" },
    { num: 7, nombre: "Julio" },
    { num: 8, nombre: "Agosto" },
    { num: 9, nombre: "Septiembre" },
    { num: 10, nombre: "Octubre" },
    { num: 11, nombre: "Noviembre" },
    { num: 12, nombre: "Diciembre" }
  ];

  constructor(
    public global: GlobalService,
    public ruta: Router,
    public modalService: NgbModal,
    public alerta: GlobalAlertService,
    private spinner: NgxSpinnerService,
    private apiProcesamientoArchivos: ApiProcesminetoArchivosService,
    public excelService: ExcelService
  ) { }

  ngOnInit(): void {
  const anioActual = new Date().getFullYear();
  for (let i = 2022; i <= anioActual; i++) {
    this.anios.push(i);
  }

  const hoy = new Date();
  this.formConsolidado.mes = hoy.getMonth();
  this.formConsolidado.anio = hoy.getFullYear();
  this.clientClass = this.global.CLIENTDATALIWA[8];
  this.id_User = this.global.CLIENTDATALIWA[0];

  this.spinner.show();

  this.cargarTodasLasSolicitudes();
}

async cargarTodasLasSolicitudes() {

  const pdata1 = {
    option: 'insertar2',
    texto: `SELECT id, id_user, mes, ano, id_seccional, id_producto, id_centro_costos, valor_dia, cantidad, subsidio, prestacion, IF(estado IS NULL OR estado = '0' OR estado = '', 0, 1) AS estado, LastInsert, LastUpdate, IsDelete, IsActive, code_producto, cu_por_mes, pago_oportuno, suspension, periodo_inicio, periodo_final, Gm, Dm, Cm FROM db_liwa.Solicitudes_Facturacion_Sumpower WHERE IsDelete = 0 ORDER BY id DESC`
  };

  const response1: any = await this.global.consultarAsync(pdata1);

  this.medidores = (response1 && response1.length > 0)
    ? response1.map((row: any) => Object.values(row))
    : [];

  console.log("TOTAL SOLICITUDES:", this.medidores.length);

  await this.cargarCostos();
}

async cargarCostos() {
  const pdata5 = { option: 'consultar-costos' };

  await this.global.consultar_siigo(pdata5, async (err5, response5) => {
console.log("Centro costos:", response5);
    this.CentroCostos = [];
    for (let index = 0; index < response5.length; index++) {
      let nombre = response5[index]['name'];
      if (nombre.includes("COMERCIAL") && !nombre.includes("COMERCIALIZACION")) {
        this.CentroCostos.push(response5[index]);
      }
    }

    await this.cargarProductos();
  });
}

async cargarProductos() {
  const pdata6 = { option: 'consultar-productos' };

  await this.global.consultar_siigo(pdata6, async (err6, response6) => {
    console.log("PRODUCTOS", response6['results']);
    this.Productos = [];
    for (let index = 0; index < response6['results'].length; index++) {
      const name = response6['results'][index]['name'];
      //if (name.includes("ZNI")) {
        this.Productos.push(response6['results'][index]);
      //}
    }

    await this.cargarSeccionales();
  });
}

async cargarSeccionales() {
  const pdata4 = {
    option: 'insertar2',
    texto: `SELECT Nombre, Id_Seccional 
            FROM db_liwa.Seccionales 
            WHERE Id_Proyecto = '58' AND IsDelete=0 AND IsActive=1;`
  };

  await this.global.consultar(pdata4, async (err4, response4) => {

    let res: any[] = response4;
    this.seccionales = (!res || res.length === 0) ? [] : response4;

    $(function () {
      this.table = $('#seccionalTable').DataTable({
        responsive: false,
        destroy: true,
        retrieve: true,
        paging: true,
        info: false,
        pagingType: 'numbers',
        orderFixed: [[0, 'desc']],
        language: {
          url: 'https://cdn.datatables.net/plug-ins/1.10.15/i18n/Spanish.json'
        }
      });
    });

    this.spinner.hide();
  });
}



  openModalConsolidado(content: any) {
    console.log('Abriendo modal consolidado');
    this.modalService.open(content, { size: 'lg', centered: true });
  }

  async generarConsolidado(modal: any) {
    const { tipo, mes, anio, seccional } = this.formConsolidado;

    if (!anio) {
      await Swal.fire({
        icon: 'warning',
        title: 'Campos requeridos',
        text: 'Debes ingresar el año para continuar.',
        confirmButtonColor: '#093579',
      });
      return;
    }

    if (tipo === 'mensual' && !mes) {
      await Swal.fire({
        icon: 'warning',
        title: 'Campos requeridos',
        text: 'Debes seleccionar el mes para el consolidado mensual.',
        confirmButtonColor: '#093579',
      });
      return;
    }

    const esAnual = tipo === 'anual';
    const nombreMes = !esAnual ? this.months[mes - 1] : null;
    const periodoTexto = esAnual
      ? `todo el <b>año ${anio}</b>`
      : `el <b>mes ${nombreMes}</b> del <b>año ${anio}</b>`;

    const confirmacion = await Swal.fire({
      title: '<strong>¿Deseas generar y descargar el consolidado?</strong>',
      html: `Se generará el archivo para ${periodoTexto}${seccional !== 'todas' ? ` en la seccional seleccionada` : ''}.`,
      icon: 'question',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: '#093579',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sí, generar',
    });

    if (!confirmacion.isConfirmed) {
      return;
    }

    const payload: any = {
      option: "consultar-solicitudes",
      anio,
      seccional,
      tipo,
    };

    if (!esAnual) {
      payload.mes = mes;
    }

    await this.global.consultar_siigo(payload, async (err, res) => {

      if (err) {
        console.error('Error al consultar:', err);
        await Swal.fire({
          icon: 'error',
          title: 'Error de conexión',
          text: 'Ocurrió un error al consultar las solicitudes.',
          confirmButtonColor: '#093579',
        });
        return;
      }

      if (!res || !Array.isArray(res.ids) || res.ids.length === 0) {
        console.warn('Respuesta vacía o sin solicitudes:', res);
        await Swal.fire({
          icon: 'error',
          title: 'Sin resultados',
          text: 'No se encontraron solicitudes para ese periodo.',
          confirmButtonColor: '#093579',
        });
        return;
      }

      const ids = res.ids;

      const payloadConsolidado = {
        option: "generar-archivo-consolidado",
        solicitudes: ids,
        seccional
      };

      await this.global.consultar_siigo(payloadConsolidado, async (err2, res2) => {
        if (err2 || !res2.data || res2.data.length === 0) {
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Ocurrió un error al generar el consolidado.',
            confirmButtonColor: '#093579',
          });
          return;
        }
        const codigoAleatorio = Math.random().toString(36).substring(2, 7).toUpperCase();
        const periodoArchivo = esAnual ? `Anual-${anio}` : `${nombreMes}-${anio}`;
        const nombreArchivo = `Consolidado-Facturacion-Suncolombia-Generacion-${periodoArchivo}-${codigoAleatorio}`;
        this.global.exportarExcel(res2.data, nombreArchivo);
        modal.close();
        await Swal.fire({
          icon: 'success',
          title: '¡Consolidado descargado!',
          text: 'El archivo se ha generado y descargado exitosamente.',
          confirmButtonColor: '#093579',
        });
      });
    });
  }

  abrirModalDuplicar(modalTemplate: any, idSolicitud: number) {
    console.log('ID de solicitud a duplicar:', idSolicitud);

    const pdatac = {
      option: 'consultar-solicitud',
      idSolicitud: idSolicitud
    };
    this.spinner.show();

    this.global.consultar_siigo(pdatac, (err, results) => {
      this.spinner.hide();

      if (err) {
        console.error('Error en la consulta:', err);
        this.alerta.descErr('Hubo un error al intentar cargar la solicitud');
        return;
      }

      console.log('Respuesta de la consulta:', results);

      if (results && results.id) {
        this.idSolicitudOriginal = results;
        console.log("Solicitud original", this.idSolicitudOriginal);
        this.duplicaciones = [1];
        this.modalService.open(modalTemplate);

      } else {
        this.alerta.descErr('No se pudo cargar la solicitud original');
      }
    });
  }

  agregarDuplicacion() {
    this.duplicaciones.push(1);
  }

  quitarDuplicacion(i: number) {
    if (this.duplicaciones.length > 1) {
      this.duplicaciones.splice(i, 1);
    } else {
      alert("Debes tener al menos una duplicación.");
    }
  }

  confirmarDuplicaciones(modalTemplate: any) {

    if (this.idSolicitudOriginal < 0) {
      this.alerta.descErr('No se ha cargado correctamente la solicitud original');
      return;
    }
    this.spinner.show();
    for (let i = 0; i < this.duplicaciones.length; i++) {
      const cantidad = this.duplicaciones[i];
      const query = `
        INSERT INTO db_liwa.Solicitudes_Facturacion_Sumpower
        (
          \`id_user\`, \`mes\`, \`ano\`, \`id_seccional\`, \`id_producto\`, \`id_centro_costos\`,
          \`valor_dia\`, \`cantidad\`, \`subsidio\`, \`prestacion\`, \`estado\`, \`code_producto\`,
          cu_por_mes, pago_oportuno, suspension, periodo_inicio, periodo_final, Gm, Dm, Cm
        ) 
        VALUES (
          '${this.idSolicitudOriginal.id_user}',  -- Usamos los valores de la solicitud original
          '${this.idSolicitudOriginal.mes}', 
          '${this.idSolicitudOriginal.ano}', 
          '${this.idSolicitudOriginal.id_seccional}', 
          '${this.idSolicitudOriginal.id_producto}', 
          '${this.idSolicitudOriginal.id_centro_costos}', 
          '${this.idSolicitudOriginal.valor_dia}', 
          '${cantidad}',  -- La cantidad se toma de duplicaciones
          '${this.idSolicitudOriginal.subsidio}', 
          '${this.idSolicitudOriginal.prestacion}', 
          '${0}', 
          '${this.idSolicitudOriginal.code_producto}', 
          ${this.idSolicitudOriginal.cu_por_mes}, 
          '${moment(this.idSolicitudOriginal.pago_oportuno).format('YYYY-MM-DD HH:mm:ss')}', 
          '${moment(this.idSolicitudOriginal.suspension).format('YYYY-MM-DD HH:mm:ss')}', 
          '${moment(this.idSolicitudOriginal.periodo_inicio).format('YYYY-MM-DD HH:mm:ss')}', 
          '${moment(this.idSolicitudOriginal.periodo_final).format('YYYY-MM-DD HH:mm:ss')}', 
          '${this.idSolicitudOriginal.Gm}', 
          '${this.idSolicitudOriginal.Dm}', 
          '${this.idSolicitudOriginal.Cm}'
        );
      `;

      const pdatac = { option: 'insertar', texto: query };
      this.global.consultar(pdatac, async (err, response) => {
        if (response) {
          console.log("Duplicación exitosa:", response);
          if (i === this.duplicaciones.length - 1) {
            this.alerta.descValid('Solicitudes duplicadas correctamente!');
            this.ngOnInit();
            modalTemplate.close();
          }
        } else {
          this.alerta.descErr('Error al duplicar solicitud');
        }
      });
    }
    this.ngOnInit();
    this.spinner.hide();
  }

  SubirExcel() {
    this.Subir = true;
  }
  async ConsultarArray(item) {    
  const pdata4 = {
    option: 'insertar',
    texto: 'SELECT estado FROM db_liwa.Solicitudes_Facturacion_Sumpower WHERE id=\'' + item + '\';'
  };
  
  const response2: any = await this.global.consultarAsync(pdata4);

  if (response2 && response2.length > 0) {
    const estado = response2[0].estado;
    this.memo = estado;
    return estado;
  } else {
    this.memo = [];
    return [];
  }

}

  incomingfile(event) {
    this.file = event.target.files[0];
  }

  Confirmar() {
    this.spinner.show();
    var query = "INSERT INTO db_liwa.Solicitudes_Facturacion_Sumpower (`id_user`,`mes`,`ano`,`id_seccional`,`id_producto`,`id_centro_costos`,`valor_dia`,`cantidad`, `subsidio`,`prestacion`,`estado`, `code_producto`,cu_por_mes,pago_oportuno,suspension,periodo_inicio,periodo_final,Gm,Dm,Cm) VALUES ('" + this.id_User +
      "','" + this.MesSel +
      "','" + this.AnoSel +
      "','" + this.IdSeccional +
      "','" + this.IdProducto +
      "','" + this.IdCentroCostos +
      "','" + this.VFacturar +
      "','" + this.Cantidad +
      "','" + this.VSubsidio +
      "','" + this.VCU + "','0'," + this.CodeProducto + "," + this.VMCU + ",'" + moment(this.Oportuno).format('YYYY-MM-DD HH:mm:ss') + "','" + moment(this.Suspende).format('YYYY-MM-DD HH:mm:ss') + "','" + moment(this.Pe_inicio).format('YYYY-MM-DD HH:mm:ss') + "','" + moment(this.Pe_final).format('YYYY-MM-DD HH:mm:ss') + "','" + this.Gm + "','" + this.Dm + "','" + this.Cm + "');";
    const pdatac = { option: 'insertar', texto: query };
    console.log("DATA", pdatac)
    this.global.consultar(pdatac, async (err4, response4) => {
      console.log("RES", response4)
      if (response4) {
        this.alerta.descValid('Registro Facturado Correctamente!');
        this.ngOnInit();
        this.MesSel = " ";
        this.AnoSel = " ";
        this.IdSeccional = " ";
        this.IdProducto = " ";
        this.IdCentroCostos = " ";
        this.VFacturar = " ";
        this.Cantidad = " ";
        this.VSubsidio = " ";
        this.VCU = " ";
        this.CodeProducto = " ";
        this.VMCU = " ";
        this.Oportuno = " ";
        this.Suspende = " ";
        this.Pe_inicio = " ";
        this.Pe_final = " ";
        this.Gm = " ";
        this.Dm = " ";
        this.Cm = " ";
        $(function () {
          this.table = $('#seccionalTable').DataTable({
            'responsive': false,
            'destroy': true,
            'retrieve': true,
            'paging': true,
            'info': false,
            'pagingType': 'numbers',
            'language': {
              'url': '//cdn.datatables.net/plug-ins/1.10.15/i18n/Spanish.json'
            }
          });
        });
        this.spinner.hide();
      } else if (response4 == null || response4 == undefined) {
        this.alerta.descErr('Ups.. Error intente de nuevo.');
        this.ngOnInit();
        this.spinner.hide();
      }
    });


  }
  prueba() {
    const data = { option: "APPP" }
    setTimeout(() => {
      this.global.consultar_siigo(data, async (err7, response7) => {
        console.log("Prueba", response7);
        if (response7) {
          this.spinner.hide();
          this.alerta.descValid('Proceso iniciado,Prueba!');
          this.ngOnInit();
        } else if (response7 == null || response7 == undefined) {
          this.spinner.hide();
          this.alerta.descErr('Error, por favor intente de nuevo!');
        }
      });
    }, 60);
  }

  RegistrarMedidores() {
    let masivo = new Array();
    /*
    Apellidos: "Hernandez Osorio"
    Cedula: 1000687826
    Comunidad: "NA"
    Departamento: "Boyacá"
    Latitud: 1223456
    Longitud: 314234235
    Municipio: "Tunja"
    Nombres: "Miguel Felipe"
    Vereda: "Centro"
    */
    if (this.Registrar == true) {
      for (let i = 0; i < this.MEDIDORESEXCEL.length; i++) {
        masivo.push({
          identificacion: this.MEDIDORESEXCEL[i].identification,
          name: this.MEDIDORESEXCEL[i].name,
          last_name: this.MEDIDORESEXCEL[i].last_name,
          address: this.MEDIDORESEXCEL[i].address,
          state_code: this.MEDIDORESEXCEL[i].state_code,
          city_code: this.MEDIDORESEXCEL[i].city_code,
          postal_code: this.MEDIDORESEXCEL[i].postal_code,
          tel: this.MEDIDORESEXCEL[i].number,
          correo: this.MEDIDORESEXCEL[i].email,
          comments: this.MEDIDORESEXCEL[i].comments
        })
      }
      setTimeout(() => {
        console.log('MASIVO DEF', masivo);

        const pdata3 = { option: 'crear-clientes', datos: masivo };
        this.global.consultar_siigo(pdata3, async (err3, response3) => {
          console.log(response3);
        });
      }, 500);
    } else {

    }
  }

  IsActiveView(data) {
    if (data == 1) {
      return 'Activado';
    }
    if (data == 0) {
      return 'Desactivado';
    }
  }
  isActiveBadge(data) {
    if (data == 1) {
      return 'badge badge-success';
    }
    if (data == 0) {
      return 'badge badge-danger';
    }
    this.ngOnInit();
  }

  openEditNumRate(content) {

    this.modalService.open(content, { ariaLabelledBy: 'modal-editNRate' }).result.then((result) => {
      // this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  openEdit(content, id) {
    this.newid = id;
    const pdata1 = { option: 'insertar2', texto: `SELECT * FROM db_liwa.Solicitudes_Facturacion_Sumpower WHERE IsDelete = "0" AND id = "${id}";` };
    console.log('listado', pdata1);
    this.global.consultar(pdata1, (err1, response1) => {
      console.log('Datos listado', response1);
      if (response1.length == 0) {
      } else {
        this.modalService.open(content, { ariaLabelledBy: 'modal-editNRate' }).result.then((result) => {
          // this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
        this.MesSelm = response1[0][2];
        this.AnoSelm = response1[0][3];
        this.IdSeccionalm = response1[0][4];
        this.IdProductom = response1[0][5];
        this.IdCentroCostosm = response1[0][6];
        this.VFacturarm = response1[0][7];
        this.VSubsidiom = response1[0][9];
        this.VCUm = response1[0][10];
        this.VMCUm = response1[0][17];
        this.Cantidadm = response1[0][8];
        this.Oportunom = moment(response1[0][18]).format('yyyy-MM-DD');
        this.Suspendem = moment(response1[0][19]).format('yyyy-MM-DD');
        this.Pe_iniciom = moment(response1[0][20]).format('yyyy-MM-DD');
        this.Pe_finalm = moment(response1[0][21]).format('yyyy-MM-DD');
        this.Gmm = response1[0][22];
        this.Dmm = response1[0][23];
        this.Cmm = response1[0][24];
      }
    });
  }

  modificarsol() {
    this.AsignarCode();
    var query = "UPDATE  db_liwa.Solicitudes_Facturacion_Sumpower SET mes ='" + this.MesSelm +
      "', ano ='" + this.AnoSelm +
      "', id_seccional ='" + this.IdSeccionalm +
      "', id_producto ='" + this.IdProductom +
      "', id_centro_costos ='" + this.IdCentroCostosm +
      "', valor_dia ='" + this.VFacturarm +
      "', cantidad ='" + this.Cantidadm +
      "', subsidio ='" + this.VSubsidiom +
      "', prestacion='" + this.VCUm + "', code_producto ='" + this.CodeProducto + "', cu_por_mes='" + this.VMCUm + "', pago_oportuno ='" + moment(this.Oportunom).format('YYYY-MM-DD HH:mm:ss') + "', suspension ='" + moment(this.Suspendem).format('YYYY-MM-DD HH:mm:ss') + "', periodo_inicio ='" + moment(this.Pe_iniciom).format('YYYY-MM-DD HH:mm:ss') + "', periodo_final='" + moment(this.Pe_finalm).format('YYYY-MM-DD HH:mm:ss') + "', Gm ='" + this.Gmm + "', Dm ='" + this.Dmm + "', Cm= '" + this.Cmm + "' WHERE id = '" + this.newid + "';";
    const pdatam = { option: 'insertar', texto: query };
    console.log(query)
    this.global.consultar(pdatam, async (err4, response4) => {
      console.log("RES", response4)
      if (response4) {
        this.alerta.descValid('Se realizo la modificacion Correctamente!');
        this.ngOnInit();
        $(function () {
          this.table = $('#seccionalTable').DataTable({
            'responsive': false,
            'destroy': true,
            'retrieve': true,
            'paging': true,
            'info': false,
            'pagingType': 'numbers',
            'language': {
              'url': '//cdn.datatables.net/plug-ins/1.10.15/i18n/Spanish.json'
            }
          });
        });
        this.spinner.hide();
      } else if (response4 == null || response4 == undefined) {
        this.alerta.descErr('Ups.. Error intente de nuevo.');
        this.ngOnInit();
        this.spinner.hide();
      }
    });
  }

  deleteSec(idSec) {
    Swal.fire({
      title: '<strong>¿Está seguro que desea eliminar el registro?</strong>',
      icon: 'question',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: '#093579',
      cancelButtonText: 'Cancelar',
      cancelButtonAriaLabel: 'Thumbs up, great!',
      confirmButtonText: 'Si, estoy seguro'
    }).then((result) => {
      if (result.isConfirmed) {
        this.eliminar(idSec);
      } else {
        this.ngOnInit();
      }
    });
  }


  EnviarAprobacion(Info) {
    this.spinner.show();
    console.log("Enviar Aprobación", Info);
    let data = {
      option: 'enviar-aprobacion',
      mes: Info[2],
      ano: Info[3],
      id_seccional: Info[4],
      name_seccional: this.nombreSeccional(Info[4]),
      id_producto: Info[5],
      id_centro_costos: Info[6],
      code_producto: Info[16],
      name_centro_costos: this.nombreCostos(Info[6]),
      valor_facturar: Info[7],
      cantidad: Info[8],
      valor_subsidio: Info[9],
      valor_prestacion: Info[10]
    }
    console.log('DATA APROBACION', data);
    setTimeout(() => {
      this.global.consultar_siigo(data, async (err7, response7) => {
        console.log("Envio Aprobación", response7);
        if (response7) {
          this.spinner.hide();
          this.alerta.descValid('Se envió correo de aprobación correctamente!');
          this.ngOnInit();
        } else if (response7 == null || response7 == undefined) {
          this.spinner.hide();
          this.alerta.descErr('Error, por favor intente de nuevo!');
        }
      });
    }, 60);
  }

  // MÉTODOS ANTIGUOS DE FACTURACIÓN
  // async GenerarFacturacion(Info) {
  //   this.spinner.show();
  //   console.log("Enviar Generacion", Info);
  //   let data = {
  //     option: 'crear-factura-dian',
  //     id_solicitud: Info[0],
  //     mes: Info[2],
  //     ano: Info[3],
  //     id_seccional: Info[4],
  //     name_seccional: this.nombreSeccional(Info[4]),
  //     id_producto: Info[5],
  //     id_centro_costos: Info[6],
  //     code_producto: Info[16],
  //     name_centro_costos: this.nombreCostos(Info[6]),
  //     valor_facturar: Info[7],
  //     cantidad: Info[8],
  //     valor_subsidio: Info[9],
  //     valor_prestacion: Info[10]
  //   }
  //   console.log('DATA Factura', data);
  //   setTimeout(() => {
  //     this.global.consultar_siigo(data, async (err7, response7) => {
  //       console.log("Envio Factura", response7);
  //       if (response7) {
  //         // setTimeout(() => {
  //         //   var query = "UPDATE db_liwa.Solicitudes_Facturacion"+environment.table+" SET IsActive = '3' WHERE id ='" + Info[0] + "';";
  //         //   const pdata1 = { option: 'insertar', texto: query };
  //         //   this.global.consultar(pdata1, async (err4, response4) => {
  //         //     console.log("RES", response4)
  //         //     if(response4){
  //         this.spinner.hide();
  //         this.alerta.descValid('Proceso iniciado, el resultado se comunicará por correo electronico!');
  //         this.ngOnInit();
  //         //     }else if(response4 == null || response4 == undefined){
  //         //       this.spinner.hide();
  //         //       this.alerta.descErr('Error, Al Actualizar!');
  //         //     }
  //         //   });
  //         // }, 60);
  //       } else if (response7 == null || response7 == undefined) {
  //         this.spinner.hide();
  //         this.alerta.descErr('Error, por favor intente de nuevo!');
  //       }
  //     });
  //   }, 60);
  // }

  // async ReFacturacion(Info) {
  //   let data = {
  //     option: 're-factura-dian',
  //     id_solicitud: Info[0],
  //     mes: Info[2],
  //     ano: Info[3],
  //     id_seccional: Info[4],
  //     name_seccional: this.nombreSeccional(Info[4]),
  //     id_producto: Info[5],
  //     id_centro_costos: Info[6],
  //     code_producto: Info[16],
  //     name_centro_costos: this.nombreCostos(Info[6]),
  //     valor_facturar: Info[7],
  //     cantidad: Info[8],
  //     valor_subsidio: Info[9],
  //     valor_prestacion: Info[10]
  //   }
  //   setTimeout(() => {
  //     this.global.consultar_siigo(data, async (err8, response8) => {
  //       console.log("Envio Factura", response8);
  //       if (response8) {
  //         // setTimeout(() => {
  //         //   var query = "UPDATE db_liwa.Solicitudes_Facturacion"+environment.table+" SET IsActive = '3' WHERE id ='" + Info[0] + "';";
  //         //   const pdata1 = { option: 'insertar', texto: query };
  //         //   this.global.consultar(pdata1, async (err4, response4) => {
  //         //     console.log("RES", response4)
  //         //     if(response4){
  //         this.spinner.hide();
  //         this.alerta.descValid('Proceso iniciado, el resultado se comunicará por correo electronico!');
  //         this.ngOnInit();
  //         //     }else if(response4 == null || response4 == undefined){
  //         //       this.spinner.hide();
  //         //       this.alerta.descErr('Error, Al Actualizar!');
  //         //     }
  //         //   });
  //         // }, 60);
  //       } else if (response8 == null || response8 == undefined) {
  //         this.spinner.hide();
  //         this.alerta.descErr('Error, por favor intente de nuevo!');
  //       }
  //     });
  //   }, 60);
  // }

  AsignarCode() {
    for (let index = 0; index < this.Productos.length; index++) {
      console.log(this.IdProducto, this.Productos[index]['id'])
      if (this.IdProducto == this.Productos[index]['id']) {
        this.CodeProducto = "'" + this.Productos[index]['code'] +"'";
      }
      if (this.IdProductom == this.Productos[index]['id']) {
        this.CodeProductom = this.Productos[index]['code']
      }
    }
    console.log("Code", this.CodeProducto)
  }

  nombreSeccional(id) {
    for (let index = 0; index < this.seccionales.length; index++) {
      // console.log(id,this.seccionales[index][1])
      if (id == this.seccionales[index][1]) {
        return this.seccionales[index][0]
      }
    }
  }

  nombreProducto(id) {
    for (let index = 0; index < this.Productos.length; index++) {
      // console.log(id,this.Productos[index]['id'])
      if (id == this.Productos[index]['id']) {
        return this.Productos[index]['name']
      }
    }
  }

  nombreCostos(id) {
    for (let index = 0; index < this.CentroCostos.length; index++) {
      // console.log(id,this.CentroCostos[index]['id'])
      if (id == this.CentroCostos[index]['id']) {
        return this.CentroCostos[index]['name']
      }
    }
  }

  eliminar(data) {
    this.spinner.show();
    setTimeout(() => {
      var query = `UPDATE db_liwa.Solicitudes_Facturacion_Sumpower SET IsDelete = '1' WHERE id ='${data}';`;
      const pdata1 = { option: 'insertar', texto: query };
      this.global.consultar(pdata1, async (err4, response4) => {
        console.log("RES", response4)
        if (response4) {
          this.spinner.hide();
          this.alerta.descValid('Registro Eliminado Correctamente!');
          this.ngOnInit();
        } else if (response4 == null || response4 == undefined) {
          this.spinner.hide();
          this.alerta.descErr('Error, por favor intente de nuevo!');
        }
      });
    }, 60);

  }

  // MÉTODOS PARA PROVISIÓN DE FACTURACIÓN
  // Función para abrir modal para carga de archivo de provisión
  openFormProvision(content) {
    this.provisionState = undefined
    this.file = undefined
    this.modalService
      .open(content, { ariaLabelledBy: "modal-vinculate" })
      .result.then(
        (result) => {
          // this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  // Función para cargar archivo de provisión
  uploadFile(ev) {
    this.file = ev.target.files[0];
    //this.subiendoandoExcel2();
  }

  // Función para descargar archivo de formato de provisión
  downloadFormat() {
    window.open("https://php.engenius.com.co/Formatos/Excel/Formato_Provision_de_Facturacion_DISPOWER.xlsx", "_blank").focus();
  }

  // Función para procesar archivo de provisión
  procesarProvision() {
    this.provisionState = undefined
    this.spinner.show();
    if (this.file) {
      this.apiProcesamientoArchivos.comprobarProvision(this.file).subscribe(
        (response: provisionData) => {
          this.spinner.hide()
          console.log(response)
          if (response.status == 'success' || response.status == 'partial-error') {
            this.provisionState = response.status == 'success' ? true : false
            this.provisionData = response
            const requestsApproved = this.provisionData.requestsApproved

            for (const request of requestsApproved) {
              const index = this.medidores.findIndex(subArray => subArray[0] === request.id_solicitud);
              let newMedidor = this.medidores[index]
              newMedidor[11] = request.provision.successRecords
              this.medidores[index] = newMedidor
            }
          } else if (response.status == 'error') {
            this.provisionState = false
            this.provisionData = response
          }
        },
        error => {
          this.spinner.hide()
          console.error(error);
          this.alerta.descErr(error.error.message)
        }
      )
      // this.modal.close()
    } else {
      this.alerta.descErr('El archivo no ha sido cargado correctamente. Por favor intentelo de nuevo')
    }
  }

  // MÉTODOS PARA FACTURACIÓN Y REFACTURACIÓN AUTOMÁTICA
  async newFacturacion(Info) {
    try {
      this.facturacionData = undefined
      this.spinner.show();
      const memo = await this.ConsultarArray(Info[0]);
      console.log("Enviar Facturación", Info,this.memo);
      let data = {
        option: 'facturacion-automatizada',
        id_solicitud_facturacion: Info[0],
        //nui_users: Info[11]
        nui_users: memo
      }
      console.log('DATA Factura', data);
      const responseFactura: facturacionData = await this.global.lectura_siigo(data)
      console.log("Respuesta Factura", responseFactura);
      if (responseFactura) {
        if (responseFactura.estado == 0 || responseFactura.estado == undefined) {
          this.spinner.hide();
          return this.alerta.descErr(responseFactura.message);
        }

        this.spinner.hide();
        responseFactura.estado == 3
          ? (this.alerta.descValid(`${responseFactura.message}`, responseFactura.detalles))
          : this.alerta.descAlert(`${responseFactura.message}`, responseFactura.detalles);
        this.facturacionData = responseFactura.detalles

        const index = this.medidores.findIndex(subArray => subArray[0] === data.id_solicitud_facturacion);
        let newMedidor = this.medidores[index]
        newMedidor[11] = JSON.stringify(responseFactura.detalles)
        newMedidor[15] = responseFactura.estado == 3 ? responseFactura.estado : 2 // Cambio IsActive para factura completa o continuar en rafactura
        this.medidores[index] = newMedidor
        // this.ngOnInit();
      } else if (responseFactura == null || responseFactura == undefined) {
        this.spinner.hide();
        this.alerta.descErr('Error, por favor intente de nuevo!');
      }
    } catch (error) {
      this.spinner.hide();
      this.alerta.descErr('Error, por favor intente de nuevo!');
    }
  }

  async newReFacturacion(Info) {
    try {
      this.reFacturacionData = undefined
      this.spinner.show();
      const memo = await this.ConsultarArray(Info[0]);
      console.log("Enviar ReFacturacion", Info);
      let data = {
        option: 'refacturacion-automatizada',
        id_solicitud_facturacion: Info[0],
        nui_users: memo
      }
      console.log('DATA ReFactura', data);

      const responseRefactura: facturacionData = await this.global.lectura_siigo(data)
      console.log("Respuesta ReFactura", responseRefactura);
      if (responseRefactura) {
        if (responseRefactura.estado == 0) {
          this.spinner.hide();
          return this.alerta.descErr(responseRefactura.message);
        }

        this.spinner.hide();
        responseRefactura.estado == 3
          ? (this.alerta.descValid(`${responseRefactura.message}`, responseRefactura.detalles))
          : this.alerta.descAlert(`${responseRefactura.message}`, responseRefactura.detalles);
        this.reFacturacionData = responseRefactura.detalles

        const index = this.medidores.findIndex(subArray => subArray[0] === data.id_solicitud_facturacion);
        let newMedidor = this.medidores[index]
        newMedidor[11] = JSON.stringify(responseRefactura.detalles)
        newMedidor[15] = responseRefactura.estado == 3 ? responseRefactura.estado : 2 // Cambio IsActive para factura completa o continuar en rafactura
        this.medidores[index] = newMedidor
        console.log('Nueva Solicitud: ', this.medidores[index])
        // this.ngOnInit();
      } else if (responseRefactura == null || responseRefactura == undefined) {
        this.spinner.hide();
        this.alerta.descErr('Error, por favor intente de nuevo!');
      }
    } catch (error) {
      console.error("Error", error.message);
      this.spinner.hide();
      this.alerta.descErr('Error, por favor intente de nuevo!');
    }
  }

  async descargaReporteReFactura(dataXLSX: string) {
    const dataJSONtoXLSX: informeFacturas[] = JSON.parse(dataXLSX)
    if (isInformeFacturas(dataJSONtoXLSX)) {
      await this.excelService.exportExcelFacturacion(dataJSONtoXLSX)
    } else {
      console.error('No hay suficientes para generar el reporte:', dataXLSX)
      await this.alerta.descErr('No hay suficientes datos para generar el reporte')
    }

    function isInformeFacturas(obj: any): obj is informeFacturas[] {
      const keysInforme = [
        'id_registro_facturacion',
        'nui',
        'success',
        'cc',
        'id_solicitud',
        'id_factura',
        'name_factura',
        'cufe_status',
        'message'
      ]
      return Array.isArray(obj) && obj.every(
        item => item !== null &&
          typeof item === 'object' &&
          !Array.isArray(item) &&
          keysInforme.every(key => key in item && item[key] != undefined)
      );
    }
  }
}
